import { computed } from 'mobx'
import { makeObservableRowBase, RowBase } from 'shared/ui/TableNew/model/RowBase'
import { TooltipLink } from 'shared/ui'
import { uiStore } from 'shared/store/uiStore'
import { type Inbox } from 'entities/Inbox/model/Inbox'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { BillingPath } from 'entities/ExportRouters'

export class RowInbox extends RowBase<Inbox> {
  constructor(origin: Inbox, private _entities: IEntitiesStore) {
    super(origin)

    makeObservableRowBase(this, {
      owner: computed,
      members: computed,
      numbersCount: computed,
      hasAircallNumber: computed,
      firstNumber: computed,
      createdAt: computed,
      isDefaultTeam: computed,
    })
  }

  get owner() {
    return this._entities.usersStore.getItem(this.origin.ownerId)
  }

  get currentUser() {
    return this._entities.usersStore.user
  }

  get isDefaultTeam() {
    return this.currentUser?.defaultTeamId === this.origin.id
  }

  get members() {
    return this.origin.memberIds.map((id) => this._entities.usersStore.getItem(id)).filter(Boolean)
  }

  get numbersCount() {
    return this.origin.numberIds.length
  }

  get hasAircallNumber() {
    return this.origin.numbers.some((number) => number?.is_aircall)
  }

  get firstNumber() {
    return this.origin.numbers[0]
  }

  get createdAt() {
    return this.origin.origin.created_at
  }

  get name() {
    return this.origin.name
  }

  get lock() {
    if (this._entities.subscriptionStore.isPAYGPlan) {
      return {
        tooltip: (
          <>
            You have reached the limit of 1 inbox on Pay
            <br />
            As You Go plan. Upgrade to remove the limits. <br />
            <TooltipLink
              text={'Upgrade'}
              onClick={() => {
                uiStore.changeRouteViaVue({
                  path: `/${BillingPath.upgrade}`,
                })
              }}
            />
          </>
        ),
      }
    }

    return false
  }
}
